// src/App.jsx - Router principal v4.0 (circuit fermé)
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store';
import { LoginPage, RegisterPage } from './pages/AuthPages';
import { ChatPage }          from './pages/ChatPage';
import { WalletPage }        from './pages/WalletPage';
import { DiasporaRechargePage as WalletRechargePage } from './pages/DiasporaRechargePage';
import { AdminPayoutPage }   from './pages/AdminPayoutPage';
import { AdminDashboard }    from './pages/AdminDashboard';
import { PricingPage }       from './pages/PricingPage';
import PrivacyPage           from './pages/PrivacyPage';
import MarketplacePage       from './pages/MarketplacePage';
import PaymentLinkPage       from './pages/PaymentLinkPage';
import LandingPage            from './pages/LandingPage';
import AProposPage            from './pages/AProposPage';
import BusinessPage           from './pages/BusinessPage';
import InvestisseursPage      from './pages/InvestisseursPage';
import ContactPage            from './pages/ContactPage';
import VerifiedChannelPage     from './pages/VerifiedChannelPage';
import BusinessApiPage          from './pages/BusinessApiPage';
import ChannelAnalyticsPage    from './pages/ChannelAnalyticsPage';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, initialized } = useAuthStore();
  if (!initialized) return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'100vh',background:'#0A0E1A',flexDirection:'column',gap:16}}>
      <div style={{width:48,height:48,border:'4px solid #1e2d45',borderTop:'4px solid #00D4AA',borderRadius:'50%',animation:'spin 0.8s linear infinite'}}/>
      <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
      <span style={{color:'#6b7fa3',fontSize:14,fontFamily:'Arial'}}>Chargement...</span>
    </div>
  );
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};
const PublicRoute = ({ children }) => {
  const { isAuthenticated, initialized } = useAuthStore();
  if (!initialized) return null;
  return !isAuthenticated ? children : <Navigate to="/chat" replace />;
};

export default function App() {
  const { initialize } = useAuthStore();
  useEffect(() => { initialize(); }, []);

  return (
    <BrowserRouter>
      <Toaster position="top-right" toastOptions={{
        style: { background:'#1a2235', color:'#E8EDF5', border:'1px solid #1e2d45', fontFamily:"'Sora', sans-serif", fontSize:14 },
        success: { iconTheme: { primary:'#00D4AA', secondary:'#000' } },
        error:   { iconTheme: { primary:'#FF4F6A', secondary:'#fff' } },
      }} />
      <Routes>
        <Route path="/"         element={<LandingPage />} />
        <Route path="/login"    element={<PublicRoute><LoginPage /></PublicRoute>} />
        <Route path="/admin"    element={<AdminDashboard />} />
        <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
        <Route path="/pricing"  element={<PricingPage />} />
        <Route path="/privacy"  element={<PrivacyPage onClose={()=>window.history.back()} />} />
        <Route path="/chat"     element={<PrivateRoute><ChatPage /></PrivateRoute>} />
        <Route path="/wallet"   element={<PrivateRoute><WalletPage /></PrivateRoute>} />
        <Route path="/wallet/recharge" element={<PrivateRoute><WalletRechargePage /></PrivateRoute>} />
        <Route path="/admin/revenus"   element={<PrivateRoute><AdminPayoutPage /></PrivateRoute>} />
        <Route path="/pay/:code"    element={<PaymentLinkPage />} />
        <Route path="/shop/:username" element={<PrivateRoute><ChatPage /></PrivateRoute>} />
        <Route path="/a-propos"      element={<AProposPage />} />
        <Route path="/business"      element={<BusinessPage />} />
        <Route path="/investisseurs" element={<InvestisseursPage />} />
        <Route path="/contact"       element={<ContactPage />} />
        <Route path="/business-api"           element={<PrivateRoute><BusinessApiPage /></PrivateRoute>} />
        <Route path="/verified-channel"        element={<PrivateRoute><VerifiedChannelPage /></PrivateRoute>} />
        <Route path="/channel-analytics/:channelId" element={<PrivateRoute><ChannelAnalyticsPage /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
